// extracted by mini-css-extract-plugin
export default {"header":"header_header__f1idb","dropdown":"header_dropdown__N9qUf","menuItem":"header_menuItem__A6zk6","hidden":"header_hidden__QGMLN"};